import React, {FC, useEffect, useState} from "react";
import {getNameByLang, localize} from "mixins/helpers";
import {Form, Radio, Skeleton, Space} from "antd";
import {IAnswer, IQuestionProps} from "./express-help-client-questionnaire.type";
import {getAnswersByQuestionId} from "./actions";

const Question: FC<IQuestionProps> = (props: IQuestionProps) => {
    const [isLoading, setIsLoading] = useState(true);
    const [answers, setAnswers] = useState<IAnswer[]>([]);

    useEffect(() => {
        setAnswers([]);
        setIsLoading(true);

        getAnswersByQuestionId(props.question.id)
            .then(
                value => {
                    setAnswers(value.data);
                }
            )
            .finally(
                () => setIsLoading(false)
            )
    }, [props.question]);

    return (
        <div className="question">
            <div className="question__questionnaire">
                {getNameByLang(props.questionnaire, props.language === 'en_150' ? 'kk_KZ' : props.language, 'questionnaire')}
            </div>
            <div className="question__title">
                {props.number}. {getNameByLang(props.question, props.language === 'en_150' ? 'kk_KZ' : props.language, 'question')}
            </div>
            <div className="question__answer-block">
                {isLoading ? (
                    <Skeleton active title={false} />
                ) : (
                    <Form layout="vertical" form={props.form} onValuesChange={props.handleAnswerSelect}>
                        <Form.Item name="answer" rules={[{ required: true, message: localize('error.required-field', props.commonTranslations) }]}>
                            <Radio.Group>
                                <Space direction="vertical">
                                    {answers.map(x => (
                                        <Radio value={x}>{getNameByLang(x, props.language === 'en_150' ? 'kk_KZ' : props.language, 'answer')}</Radio>
                                    ))}
                                </Space>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                )}
            </div>
        </div>
    );
};

export default Question;
